<template>
  <el-row :gutter="15">
    <el-col :span="6">
      <h3>Vertical Image</h3>
      <app-placeholder-vertical :imageId="form.imageId" @upload="onUpload"/>
    </el-col>
  </el-row>
</template>

<script>
import AppPlaceholderVertical from '@/components/App/AppPlaceholderVertical'

export default {
  components: {
    AppPlaceholderVertical,
  },
  props: {
    ingredient: Object,
  },
  data() {
    return {
      form: {
        imageId: this.ingredient.image_v_id,
      }
    }
  },
  methods: {
    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/ingredients/${ this.ingredient.id }/image`, {
          image_id: imageId,
          orientation: 'v',
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }
      this.form.imageId = imageId
      this.$message.success(data.message)
    },
  },
}
</script>
